<section class="our-services-v2">
  <div class="our-services-v2-container">
    <header class="our-services-v2-header-container">
      <svg
        width="61"
        height="61"
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30.311" cy="30.5" r="30.311" fill="#00030A" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.4489 24.6946L39.2529 30.4999L33.4489 36.3052L32.5049 35.3612L36.7009 31.1666H21.6436V29.8332H36.7009L32.5049 25.6386L33.4489 24.6946Z"
          fill="#FAF2F2"
        />
      </svg>

      <h4>our services</h4>
    </header>
  </div>
  <div class="our-services-v2-body-container">
    <div data-aos="fade-in" data-aos-delay="200" class="service-item">
      <div class="content">
        <h3 class="header">
          Procurement
          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </h3>
        <p class="subtext">
          <span>
            Marihub's marine procurement service offers a seamless and efficient
            process for sourcing, acquiring, and managing various goods and
            services in the maritime sector, optimizing supply chain operations.
          </span>

          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </p>
      </div>
      <div class="underlay"></div>
    </div>
    <div data-aos="fade-in" data-aos-delay="400" class="service-item">
      <div class="content">
        <h3 class="header">
          Digital Transformation
          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </h3>
        <p class="subtext">
          <span>
            Marihub's cutting-edge digital platform is a game-changer in marine
            procurement, driving unprecedented efficiency, promoting data
            transparency and seamless collaboration for a more agile and
            competitive supply chain ecosystem.
          </span>

          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </p>
      </div>
      <div class="underlay"></div>
    </div>
    <div data-aos="fade-in" data-aos-delay="600" class="service-item">
      <div class="content">
        <h3 class="header">
          A full-service facilitator
          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </h3>
        <p class="subtext">
          <span>
            Whether it’s food provision, oil lubericant, spare parts, or fuel,
            Marihub offers unparalleled access to services from a network of
            collaborators. Ensuring exceptional quality, lower costs and faster
            services across the product lineup.
          </span>

          <svg
            class="arrow"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.29289"
              y1="29.1142"
              x2="28.9355"
              y2="1.47161"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="7.30176"
              y1="1.17871"
              x2="29.6426"
              y2="1.17871"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="28.6416"
              y1="24.7095"
              x2="28.6416"
              y2="2.17886"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </p>
      </div>
      <div class="underlay"></div>
    </div>
  </div>
</section>
